import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined

export function initSentry(): void {
    if (!DSN) return

    Sentry.init({
        dsn: DSN,
        environment: import.meta.env.MODE, // "development" | "production"
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],
        // Captura 10% das transações de performance (custo baixo)
        tracesSampleRate: 0.1,
        // Grava replay de sessão em 100% dos erros
        replaysOnErrorSampleRate: 1.0,
        // Não grava replay em sessões normais sem erro
        replaysSessionSampleRate: 0,
    })
}

export function setSentryUser(user: {
    id: string
    email: string
    name: string
    organization: string
}): void {
    if (!DSN) return
    Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.name,
        organization: user.organization,
    })
}

export function clearSentryUser(): void {
    if (!DSN) return
    Sentry.setUser(null)
}

export function captureError(
    error: unknown,
    context?: Record<string, unknown>
): void {
    if (!DSN) {
        console.error('[Sentry disabled]', error, context)
        return
    }
    Sentry.captureException(error, context ? {extra: context} : undefined)
}
